export const attendance = {
    inTime: null,
    outTime: null,
    isLoading: true
}

export const dashboardData = {
    isLoading: true,
    calendar: [],
    incompleteAttendance: [],
    employeeAttendanceSummary: [],
    userRole: '',
    employeeId: ''
};

export const adminData = {
    adminUsers: [],
    attendanceReport: [],
    employeeLeaveReport: [],
    taxSavingType: [],
    mapEmployeeRecords: [],
    userContainerPermission: [],
    containers: [],
    isLoading: true
};
export const employeeData = {

    users: [],
    role: [],
    employeesAttendance: [],
    totalHours: [],
    todayAttendanceDate: [],
    employeeLeaves: [],
    leaveRecord: [],
    holidays: [],
    workLogs: [],
    allProjects: [],
    allTasks: [],
    taxSaving: { isLoading: true, taxSavings: [] },
    taxSavingRecords: { isLoading: true, taxSavings: [] },
    taxSavingReport: { isLoading: true, taxSavingReport: [] },
    taxSavingTypes: [],
    getEmployeeData: [],
    employeeLeaveCount: [],
    data: [],
    editEmp: [],
    employeeId: '',
    year: '',
    isLoading: true
}


const PersistedState = {
    attendance: attendance,
    dashboardData: dashboardData,
    adminData: adminData,
    employeeData: employeeData
}

export default PersistedState;
